export const sharedClassNames = {
  cursorPointer: 'cursor-pointer',
  truncate: 'truncate',
  selectNone: 'select-none',
  // Border-radius
  borderRadius2: 'rounded-2',
  borderRadius3: 'rounded-3',
  borderRadius4: 'rounded-4',
  borderRadius5: 'rounded-5',
  borderRadius6: 'rounded-6',
  borderRadius8: 'rounded-8',
  borderRadius12: 'rounded-12',
  borderRadius16: 'rounded-16',
  borderRadius17: 'rounded-17'
}
